export function isFacebookWebview(): boolean {
  // Facebook sign keys.
  const keys = ["fban", "fbav"];

  const userAgent = window.navigator.userAgent || window.navigator.vendor;
  return keys.some((key) => userAgent.toLowerCase().includes(key));
}
